export const data = [
  /* Description Tab */
  {
    id: 1,
    title: {
      pt: "Descrição",
      eng: "Description",
    },
    description: {
      title: {
        pt: "Um pouco sobre mim",
        eng: "A little about me",
      },
      p1: {
        eng: "I'm João Guedes — a Software Engineer turned Application Security Engineer who’s passionate about building reliable systems and making them safer. My journey started in software development, maintaining and modernizing backend services, automating CI/CD pipelines, and improving internal infrastructure. Over time, my curiosity for how systems break and how to protect them led me to application security, where I now research vulnerabilities, develop analysis platforms, and strengthen software from the inside out.",
      },
      p2: {
        eng: "I enjoy working where engineering and security meet — designing tools that help developers, researchers, and security teams work smarter and faster. I love diving deep into complex systems, understanding how they behave, and finding creative ways to make them more efficient and secure. Outside of work, I’m always exploring new technologies and learning something new — because for me, mastering technology is a continuous process, not a destination.",
      },
    },
  },

  /* Soft Skills Tab */
  {
    id: 2,
    title: {
      pt: "Soft Skills",
      eng: "Soft Skills",
    },
    description: {
      title: {
        pt: "As minhas Soft Skills",
        eng: "My Soft Skills",
      },
      soft_skills: {
        pt: [
          "Trabalhador",
          "Trabalhador Ético",
          "Interessado",
          "Investido",
          "Trabalhador de Equipa",
          "Auto-Suficiente",
          "Adaptável",
        ],
        eng: [
          "Hard Worker",
          "Ethical Worker",
          "Interested",
          "Invested",
          "Team Worker",
          "Self Sufficient",
          "Adaptable",
        ],
      },
    },
  },

  /* Technical Skills Tab */
  {
    id: 3,
    title: {
      pt: "Habilidades Técnicas",
      eng: "Techinal Skills",
    },
    description: {
      title: {
        pt: "As minhas Habilidades Técnicas",
        eng: "My Technical Skills",
      },
      tech_list: [
        {
          name: "Javascript",
          level: "full",
        },
        {
          name: "React/Angular",
          level: "semi-full",
        },
        {
          name: "Python",
          level: "full",
        },
        {
          name: "Express",
          level: "full",
        },
        {
          name: "C#",
          level: "semi-full",
        },
        {
          name: "Sklearn",
          level: "semi-full",
        },
        {
          name: "R",
          level: "semi-full",
        },
        {
          name: "HTML/CSS",
          level: "semi-full",
        },
        {
          name: "Java",
          level: "semi-full",
        },
        {
          name: "SQL",
          level: "full",
        },
      ],
    },
  },

  /* Interests Tab */
  {
    id: 4,
    title: {
      pt: "Interesses",
      eng: "Interests",
    },
    description: {
      title: {
        pt: "Os meus Interesses",
        eng: "My Interests",
      },
      int_list: [
        "Coding",
        "Math",
        "Machine Learning",
        "Gymnastics",
        "Robotics",
        "Creating",
        "Web (Dev)",
        "Dogs",
        "Gaming & Game Dev",
        "Coffee",
      ],
    },
  },

  /* About this App Tab */
  {
    id: 5,
    title: {
      pt: "Sobre esta App",
      eng: "About this App",
    },
    description: {
      title: {
        pt: "Sobre esta App",
        eng: "About this App",
      },
      sub1: {
        pt: "Esta App foi desenvolvida com",
        eng: "This app was built with",
      },
      sub2: {
        pt: "Utilizando o meu próprio design original, explore-o aqui",
        eng: "Using my own original design, check it out",
      },
      tech: ["react", "motion", "jsx", "css"],
      apps: ["Dribbble", "Figma"],
      url: {
        drib: "https://dribbble.com/JoaoGuedes01/about",
        figma:
          "https://www.figma.com/file/WcI8gtXQuVyqv5AATpVyRp/Personal-Web-Portfolio",
      },
    },
  },
];
